import { AlertTriangle } from "lucide-react";
import type { BillingException } from "@shyne/shared/api";
import { billingExceptionText } from "@/lib/billing-exception";

export default function BillingExceptionNote({ billingException }: { billingException: BillingException | null | undefined }) {
  if (!billingException) return null;
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-amber-700 dark:text-amber-400">
      <AlertTriangle className="h-3.5 w-3.5" />
      {billingExceptionText(billingException)}
    </span>
  );
}
